export const NoFireworksIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="0.7" />
        <path
          d="M12.6665 5.15111C12.3211 4.40669 12.1485 4.03448 11.8437 4.00303C11.539 3.97158 11.3041 4.30173 10.8341 4.96202L10.7126 5.13284C10.579 5.32048 10.5123 5.41429 10.4161 5.47082C10.32 5.52734 10.2053 5.54018 9.97605 5.56585L9.76731 5.58922C8.96047 5.67956 8.55706 5.72472 8.4371 6.00584C8.31715 6.28696 8.5601 6.61786 9.04599 7.27965L9.1717 7.45087C9.30978 7.63893 9.37882 7.73296 9.40387 7.84306C9.42891 7.95316 9.40713 8.06686 9.36357 8.29427L9.32391 8.5013C9.17061 9.30155 9.09396 9.70168 9.32454 9.90687C9.55513 10.1121 9.94024 9.98642 10.7105 9.73514L10.9097 9.67013C11.1286 9.59872 11.238 9.56302 11.3497 9.57454C11.4613 9.58606 11.5625 9.6435 11.7648 9.75837L11.949 9.86295C12.6611 10.2672 13.0172 10.4693 13.2796 10.315C13.5421 10.1607 13.5372 9.75217 13.5273 8.93508L13.5247 8.72368C13.5219 8.49149 13.5205 8.3754 13.5645 8.27242C13.6084 8.16944 13.6927 8.09123 13.8613 7.93482L14.0149 7.79242C14.6083 7.24201 14.905 6.9668 14.8366 6.66625C14.7682 6.36569 14.3801 6.23884 13.6037 5.98513L13.4029 5.91949C13.1823 5.84739 13.072 5.81134 12.9875 5.73618C12.903 5.66101 12.854 5.55524 12.7558 5.3437L12.6665 5.15111Z"
          stroke={fill}
          strokeWidth="0.7"
        />
        <path
          d="M11.4265 20.001C11.1598 18.2675 10.7864 14.2404 11.4265 12.0002"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
        <path
          d="M14.2269 20.001C14.2269 17.334 15.427 12.8003 20.2275 10"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
        <path
          d="M6.62616 13.0146C6.62616 13.0146 7.14591 13.613 7.60433 13.7358C8.06275 13.8586 8.81202 13.6003 8.81202 13.6003C8.81202 13.6003 8.2137 14.1201 8.09086 14.5785C7.96803 15.0369 8.22632 15.7862 8.22632 15.7862C8.22632 15.7862 7.70658 15.1879 7.24816 15.065C6.78974 14.9422 6.04047 15.2005 6.04047 15.2005C6.04047 15.2005 6.63879 14.6808 6.76162 14.2223C6.88445 13.7639 6.62616 13.0146 6.62616 13.0146Z"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 5.5L5.50002 18.4998"
          stroke="black"
          strokeWidth="0.7"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
